module.exports = __webpack_public_path__ + "assets/icon-notifications.b69cb411.svg";